export const actions = {
  async fetchDetailSettingsByCode({commit}, detailCode) {
    return await this.$axios.$get('/UserSetting/' + detailCode)
  },
  async saveDetailSetting({commit}, {detailSettings}) {
    return await this.$axios.$post('/UserSetting/' + detailSettings.key, detailSettings)
  },
}
